// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2cAlr","title":"Images90_title__1hq4E","images":"Images90_images__281KN"};